import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../auth.service';
import { AuthUtil } from '../utils/auth.util';
import { UserPermission } from '../../../../classes/user/user-permission';

@Directive({
  selector: '[appUserHasPermission], [appUserExceptPermission]',
})
export class UserHasPermissionDirective {
  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private auth: AuthService
  ) {}

  @Input() set appUserHasPermission(userPermissions: UserPermission[]) {
    if (AuthUtil.isContainUserPermission(userPermissions, this.auth.getUserRoles())) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  @Input() set appUserExceptPermission(userPermissions: UserPermission[]) {
    if (!AuthUtil.isContainUserPermission(userPermissions, this.auth.getUserRoles())) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
